"use client";

import * as React from "react";

import { DomainHooksProvider } from "~/context/domain-hooks-context/domain-hooks-context";
import { domainHooksRegistry } from "~/context/domain-hooks-context/domain-hooks-registry";
import { AppConfigParams } from "@constructr-sdk/core/config/types/app-config-types";
import { User } from "@constructr-sdk/auth";
import { ModulesProviders } from "@constructr-sdk/modules/foundation";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { TRPCReactProvider } from "~/trpc/react";

export function Providers({
  children,
  appConfig,
  isPreviewMode,
  userDto,
}: React.PropsWithChildren & {
  isPreviewMode: boolean;
  appConfig: AppConfigParams;
  userDto?: User;
}): React.JSX.Element {
  const queryClient = new QueryClient();

  return (
    <ModulesProviders appConfig={appConfig} isPreviewMode={isPreviewMode} userDto={userDto}>
      <TRPCReactProvider>
        <QueryClientProvider client={queryClient}>
          <DomainHooksProvider registry={domainHooksRegistry}>
            {children}
          </DomainHooksProvider>
        </QueryClientProvider>
      </TRPCReactProvider>
    </ModulesProviders>
  );
}
